import {
    UniversityAction,
    UniversityActionType,
} from '../actions/UniversityActions';
import { University } from '../types';

const universityReducer = (
    state: University | null = null,
    action: UniversityAction
) => {
    switch (action.type) {
        case UniversityActionType.GET_UNIVERSITY:
            return action.payload;
        case UniversityActionType.UPDATE_UNIVERSITY:
            return action.payload;
        default:
            return state;
    }
};

export default universityReducer;
